// extracted by mini-css-extract-plugin
module.exports = {"container":"gH","image":"gI","title":"gJ","date":"gK"};